import * as types from "../../constants/actionTypes";

export const setLoader = (data) => {
    return {
        type: types.MODULE_OBAT_SET_LOADER,
        value: data
    }
};

export const getDataObat =  (value) => {
    return ({
        type: types.MODULE_OBAT_DATA_GET,
        value
    })
}

export const getObatMasuk =  (value) => {
    return ({
        type: types.MODULE_OBAT_MASUK_DATA_GET,
        value
    })
}

export const getObatKeluar =  (value) => {
    return ({
        type: types.MODULE_OBAT_KELUAR_DATA_GET,
        value
    })
}

export const initFormObat = (value) => {
    return ({
        type: types.MODULE_OBAT_INIT_FORM_OBAT,
        value
    })
}
// 
export const initFormObatMasuk = (value) => {
    return ({
        type: types.MODULE_OBAT_MASUK_INIT_FORM_OBAT,
        value
    })
}

export const getMasterData =  () => {
    return ({
        type: types.MODULE_OBAT_MASTER_DATA,
    })
}

export const handleStateForm =  (property, value) => {
    return ({
        type: types.MODULE_OBAT_HANDLE_STATE_FORM,
        property,
        value
    })
}

export const handleStateForm2 =  (property, value) => {
    return ({
        type: types.MODULE_OBAT_MASUK_HANDLE_STATE_FORM,
        property,
        value
    })
}

export const postForm = (history, value) => {
    return ({
        type: types.MODULE_OBAT_SUBMIT_FORM,
        history,
        value
    })
}

export const postForm2 = (history, value) => {
    return ({
        type: types.MODULE_OBAT_MASUK_SUBMIT_FORM,
        history,
        value
    })
}






